import React from "react";
import JSONNestedNode from "./JSONNestedNode";
import type { CommonInternalProps } from "./types";
// Returns the "n Items" string for this node,
// generating and caching it if it hasn't been created yet.
function createItemString(data: unknown) {
    const len = Object.getOwnPropertyNames(data).length;
    const label = "variant";
    return `${len} ${len !== 1 ? label + "s" : label}`;
}
interface Props extends CommonInternalProps {
    data: unknown;
}
// Configures <JSONNestedNode> to render an Object
export default function JSONObjectNode({ data, ...props }: Props) {
    return <JSONNestedNode {...props} data={data} nodeTypeIndicator="" createItemString={createItemString} expandable={Object.getOwnPropertyNames(data).length > 0}/>;
}
